import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import Container from '@mui/material/Container';

import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';
import MLFulfill from '@/sections/plugins/MLFulfill';

const MLFulfillPage = () => {
  usePageTitle('Integraciones - Mercado Libre Fulfill99');

  return (
    <Container maxWidth="xxl">
      <SectionTitle title="Mercado Libre Fulfill99" mt={5}>
        <LocalShippingOutlinedIcon fontSize="large" />
      </SectionTitle>

      <MLFulfill />
    </Container>
  );
};

export default MLFulfillPage;
